import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { Form } from 'antd';
import clsx from 'clsx';
import { fetchSpeaker } from 'api/speaker-api-v2';
import { useSession } from 'components/Authenticated';
import DraggableModalPositioned from 'components/DraggableModalPositioned';
import { useMuteShortcuts } from 'libs/shortcuts';
import SpeakerDialogHeader from './SpeakerDialogHeader';
import SpeakerDialogTabs from './SpeakerDialogTabs';
import SpeakerDialogFooter from './SpeakerDialogFooter';
import styles from './style.module.less';
const SpeakerModal = ({ mode, onSubmit, onClose, replacedSpeaker, languages, defaultSpeakerColor, isCaptionMode = false, replaceEverywhere = false, isReplacedWithCitation, removeSpeaker, getEditorSpeaker, editedId, onEditedIdChange, documentSpeakersOnly = false, }) => {
    const [dbSpeaker, setDbSpeaker] = useState(null);
    const [activeTab, setActiveTab] = useState(mode);
    const [submitState, setSubmitState] = useState('idle');
    const { session } = useSession();
    useMuteShortcuts(true, 'Tab', 'Shift+Tab');
    const [selectForm] = Form.useForm();
    const [editForm] = Form.useForm();
    const [createForm] = Form.useForm();
    const formByTab = {
        select: selectForm,
        edit: editForm,
        create: createForm,
    };
    const isReplacing = replacedSpeaker !== undefined;
    const fetchSpeakerFromDb = async (speakerDbid) => {
        if (speakerDbid === null) {
            setDbSpeaker(null);
            return;
        }
        const result = await fetchSpeaker(session.connection, speakerDbid);
        if (result.isSuccess()) {
            setDbSpeaker(result.get());
        }
        else {
            setDbSpeaker(null);
        }
    };
    useEffect(() => {
        if (isReplacing && !documentSpeakersOnly) {
            void fetchSpeakerFromDb(replacedSpeaker.dbid);
        }
    }, []);
    useEffect(() => {
        setActiveTab(mode);
    }, [mode]);
    const handleTabChange = useCallback((key) => {
        setActiveTab(key);
    }, []);
    return (_jsx(DraggableModalPositioned, { storageKey: "speaker", title: (_jsx(SpeakerDialogHeader, { isSpeakerInDb: dbSpeaker !== null, replacedSpeaker: replacedSpeaker, mode: mode })), className: clsx(styles.dialog, 'beey-tutorial-step-speaker-modal'), onClose: onClose, dialogSize: { width: 500, height: 600 }, defaultFractionalPos: {
            widthFraction: 0.35,
            heightFraction: 0.25,
        }, backdrop: true, children: _jsxs("div", { className: styles.content, children: [_jsx(SpeakerDialogTabs, { mode: mode, activeTab: activeTab, onTabChange: handleTabChange, replacedSpeaker: isReplacing
                        ? {
                            editorSpeaker: replacedSpeaker,
                            dbSpeaker,
                            isCitation: isReplacedWithCitation !== null && isReplacedWithCitation !== void 0 ? isReplacedWithCitation : false,
                        }
                        : undefined, onClose: onClose, languages: languages, onSubmit: onSubmit, selectForm: selectForm, editForm: editForm, createForm: createForm, setSubmitState: setSubmitState, isReplacedWithCitation: isReplacedWithCitation, replaceEverywhere: replaceEverywhere, isCaptionMode: isCaptionMode, defaultSpeakerColor: defaultSpeakerColor, getEditorSpeaker: getEditorSpeaker, editedId: editedId, onEditedIdChange: onEditedIdChange }), _jsx(SpeakerDialogFooter, { activeTab: activeTab, onCancel: onClose, onRemoveOccurrence: removeSpeaker, form: formByTab[activeTab], submitState: submitState, isReplacing: isReplacing })] }) }));
};
export default SpeakerModal;
